import 'bootstrap-sass';
import 'jquery-match-height';
import 'jquery-jpostal-ja';

import { webfont } from "./modules/webfont";
import { smoothScroll } from "./modules/smoothScroll";
// import { pageTop } from "./modules/page-top";
import { jqueryvalidation } from "./modules/jqueryvalidation";
import { menuTrigger } from "./modules/menu-trigger";
import { waypoints } from "./modules/waypoints";
import { isMobile } from "./modules/isMobile";
import "./modules/form";
import "./modules/list-link";
import "./modules/jpostal";
import "./modules/modal-control";
import "./modules/slider";
import "./modules/menu-fixed";
// import ScrollMagic from 'scrollmagic'

